import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { AuthLogo } from '@assets';

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
	align-items: center;
`;

const Title = styled.div`
  margin: 24px;
  color: #2A2A2A;
  text-align: left;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
	width: 100%;
`;

const RulesContainer = styled.div`
  color: #2A2A2A;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
`;

const Rules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	if (!state) {
		return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
	}

	const ruleText =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? state.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
			? state.text_mm
			: state.text_ch;
	return (
		<>
			<Topbar title={t("spin.rule")} goBack={goBack} shadow={false} />
			<RootContainer>
				<AuthLogo/>
				<Title> {t("spin.ruleTitle")} </Title>
				<RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
			</RootContainer>
		</>
	);
};

export default Rules;
